module.exports = __webpack_public_path__ + "static/media/wishlist_new.89dfd954.svg";